exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".socialIcon-root-2AQ {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    height: 100%;\n    max-width: 4rem;\n    max-height: 4rem;\n    border-radius: 0.5rem;\n    padding: 0;\n}\n\n.socialIcon-icon-3lj {\n    margin: auto;\n    display: block;\n    width: 60%;\n    height: 60%;\n    background-size: contain;\n    background-repeat: no-repeat;\n    background-position: center;\n}\n", ""]);

// Exports
exports.locals = {
	"root": "socialIcon-root-2AQ",
	"icon": "socialIcon-icon-3lj"
};